import React from 'react';
import MessagingView from "./MessagingView";
import TaskMessaging from "../../../ws/TaskMessaging";
import { CenterManager, LoadingView } from '@cuatroochenta/co-admin-react-library';
import ReplyScreen from '../replyScreen/ReplyScreen';
import { User } from '../../../model/domain/user';
import { ShareResidentOption } from '../../../model/domain/share-option';
import { Conversation, MessagingGroup } from '../../../model/domain/messaging';
import { CreateConversationRequest } from '../../../model/data/messaging';

interface ApiResponseConversation {
    code: string;
    data: {
        total_pages: number;
        total_count: number;
        current_page: number;
        limit: number;
        conversations: Conversation[];
        messagingGroups?: MessagingGroup[];
    };
}

interface State {
    conversations: Conversation[];
    messagingGroups?: MessagingGroup[];
    user: User;
    currentPage: number;
    totalPages: number;
    fetchingMore: boolean;
    filters: {

    };
    loading: boolean;
    error: Error | null;
    selectedConversation: Conversation | null;
    showCreateButton: boolean;
    showCreateModal: boolean;
    residentShareOptions?: ShareResidentOption[];
    loadingShareOptions: boolean;
    loadingCreateConversation: boolean;
    errorCreateConversation: Error | null;
}

class MessagingContainer extends React.Component<{}, State> {

    state: State = {
        conversations: [],
        messagingGroups: [],
        user: {
            success: false,
            code: 0,
            data: {
                id: 0,
                fullName: '',
                email: '',
                address: null,
                city: null,
                county: null,
                phone: null,
                postalCode: null,
                userName: '',
                profileColor: undefined,
                roles: [],
                ddbbResiplusId: 0,
                createNewsPermission: false,
                profilePicturePath: null
            }
        },
        currentPage: 1,
        totalPages: 1,
        fetchingMore: false,
        filters: {

        },
        loading: false,
        error: null,
        selectedConversation: null,
        showCreateButton: false,
        showCreateModal: false,
        loadingShareOptions: false,
        loadingCreateConversation: false,
        errorCreateConversation: null
    };

    componentDidMount() {
        this.getConversations();
        window.addEventListener('scroll', this.handleScroll, true);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true);
    }

    handleScroll = () => {
        const { currentPage, totalPages, fetchingMore, loading, filters, selectedConversation } = this.state;

        if (loading || fetchingMore || selectedConversation) return;
        const scrollTop = document.documentElement.scrollTop;
        const windowHeight = window.innerHeight; 
        const scrollHeight = document.documentElement.scrollHeight; 
    
        if (scrollTop + windowHeight >= scrollHeight - 1) {
            if (currentPage < totalPages) {
                this.setState({ fetchingMore: true });
                this.getConversations(currentPage + 1, filters);
            }
        }
    };

    private handleCreateStart = () => {
        this.getResidentShareOptions();
        this.setState({ showCreateModal: true });
    }

    private handleCreateCancel = () => {
        this.setState({ showCreateModal: false });
    }

    private getResidentShareOptions = async () => {
        try {
            this.setState({
                loadingShareOptions: true,
                errorCreateConversation: null
            });
            const response = await new TaskMessaging().getShareOptions()
            const selectedCenter = CenterManager.getSelectedCenter();
            const residentShareOptions = response.find(
                centerShareOption => centerShareOption.id.toString() === selectedCenter
            )?.suboptions;
            this.setState({ residentShareOptions })
        } catch (err) {
            if (err instanceof Error) {
                this.setState({ errorCreateConversation: err });
            }
        } finally {
            this.setState({ loadingShareOptions: false });
        }
    }

    private handleCreateConversation = (formData: CreateConversationRequest) => {
        const {
            groupId: messagingGroupId,
            recipient: familiarId,
            subject,
            body: message
        } = formData;
        const messagingGroupsLength = this.state.messagingGroups?.length ?? 0;
        if (
            (!messagingGroupId && messagingGroupsLength > 1) ||
            !familiarId ||
            !subject.trim() ||
            !message.trim()
        ) {
            this.setState({ errorCreateConversation: new Error('common.TR_ERROR_EMPTY_FIELDS') });
            return;
        }

        this.createConversation(formData);
    }

    private createConversation = async (formData: CreateConversationRequest) => {
        try {
            this.setState({
                loadingCreateConversation: true,
                errorCreateConversation: null
            });
            const conversation = await new TaskMessaging().createConversation(formData);
            this.setState({
                showCreateModal: false,
                conversations: [conversation, ...this.state.conversations],
            });
        } catch (err) {
            if (err instanceof Error) {
                this.setState({ errorCreateConversation: err });
            }
        } finally {
            this.setState({ loadingCreateConversation: false });
        }
    }

    private handleConversationClick = (conversation: Conversation) => {
        this.setState({ selectedConversation: conversation });
    };

    public getConversations(page: number = 1, filters: any = this.state.filters) {
        this.setState({ loading: true });

        const url = this.buildUrl(page, filters);

        new TaskMessaging().getConversations(url)
            .catch(
                (error: Error) => {
                    console.error('Error al obtener las conversaciones:', error);
                    this.setState({ error, loading: false, fetchingMore: false });
                }
            )
            .then(
                (data: ApiResponseConversation) => {
                    if (data.code && data.data) {
                        const newConversations = data.data.conversations.map(conversation => ({
                            ...conversation
                        }))

                        this.setState(prevState => ({
                            conversations: [...prevState.conversations, ...newConversations],
                            totalPages: data.data.total_pages,
                            currentPage: data.data.current_page,
                            loading: false,
                            fetchingMore: false,
                            showCreateButton: !!data.data.messagingGroups?.length,
                            messagingGroups: data.data.messagingGroups
                        }))
                    } else {
                        this.setState({ error: new Error('No se encontraron conversaciones'), loading: false });
                    }


                }
            )
    }

    

    buildUrl( page: number, filters: any) {
        let url = `?page=${page}`;
        return url;
    }

    public render() {
        const {
            conversations,
            messagingGroups,
            loading,
            error,
            fetchingMore,
            selectedConversation,
            showCreateButton,
            showCreateModal,
            residentShareOptions,
            loadingShareOptions,
            loadingCreateConversation,
            errorCreateConversation
        } = this.state;

        if (loading && conversations.length === 0) {
            return <LoadingView loading={loading} />;
        }

        if (error) {
            return <div>Error: {error.message}</div>;
        }

        return (
            <>
                {selectedConversation ? (
                    <ReplyScreen
                        conversation={selectedConversation}
                        onClose={() => {
                            this.setState({ selectedConversation: null, conversations: [] }, () => {
                                this.getConversations();
                            });
                        }}
                    />
                ) : (
                    <MessagingView
                        showCreateButton={showCreateButton}
                        showCreateModal={showCreateModal}
                        conversations={conversations}
                        messagingGroups={messagingGroups}
                        selectedConversation={selectedConversation}
                        residentShareOptions={residentShareOptions}
                        loadingShareOptions={loadingShareOptions}
                        loadingCreateConversation={loadingCreateConversation}
                        errorCreateConversation={errorCreateConversation}
                        onCreateStart={this.handleCreateStart}
                        onCreateCancel={this.handleCreateCancel}
                        onCreateFinish={this.handleCreateConversation}
                        onConversationClick={this.handleConversationClick}
                    />
                )}
                {fetchingMore && (
                    <div
                        style={{
                            position: 'relative',
                            marginTop: '5%',
                            width: window.innerWidth < 1024 ? '100%' : '70%',
                            textAlign: 'center',
                            padding: '10px 0',
                            zIndex: 9999,
                        }}
                    >
                        <LoadingView loading={fetchingMore} />
                    </div>
                )}
            </>
        );

    }

}

export default MessagingContainer;